import './ChartFocus.scss'
import {CHART_FOCUSES, getChartFocus, setChartFocus} from "../../../ducks/chart-duck.js";
import {useDispatch, useSelector} from "react-redux";
import {activateWidePopup} from "../../../ducks/popup-duck.js";
import ChartSettings from "../../settings/ChartSettings.jsx";
import TuneVariantIcon from "mdi-react/TuneVariantIcon.js";

export default () => {

    const dispatch = useDispatch()

    return (
        <div className='chart-focus'>
            <div className='buttons children-slide-down flex-vertical-center'>
                <button
                    className='settings'
                    onClick={() => dispatch(activateWidePopup(<ChartSettings/>))}
                >
                    <TuneVariantIcon/>
                </button>
                {Object.keys(CHART_FOCUSES).map(id => <Focus key={id} id={id}/>)}
            </div>
        </div>
    )
}

const Focus = ({id}) => {
    const dispatch = useDispatch()
    const current = useSelector(getChartFocus)
    return (
        <button
            className={current === id ? `is-selected` : ``}
            onClick={() => dispatch(setChartFocus(id))}
        >
            {CHART_FOCUSES[id].name}
        </button>
    )
}